import { INDIVIDUAL_SLOTS, GraduationServicePath, SCHEDULES } from "utils/constants";
import permissions from "app/permissions";
import UpdateStudents from "./UpdateStudents";

export const resources = {
  isMenu: false,
  name: GraduationServicePath + INDIVIDUAL_SLOTS + "/" + SCHEDULES + "/:id/intervals/students",
  title: "Студенти",
  custom: <UpdateStudents />,
  permission: permissions.canPreviewInternshipSchedules,
};
